// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.repostajes > :not(:first-child) {
  border-top: none;
}

table.repostajes tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  text-align: center;
}

table.repostajes > thead > tr > th:last-child,
table.repostajes > tbody > tr > td:last-child {
  text-align: left;
}

table.repostajes td {
  font-weight: 600;
  padding-bottom: 1.75em;
  padding-top: 1.75;
  text-align: center;
  vertical-align: middle;
}

.repostajes-fecha {
  color: #a098ae;
  font-weight: 600 !important;
}

.repostajes-matricula {
  text-transform: uppercase;
}

span.repostajes-fecha-hora {
  display: block;
  font-weight: 400;
  font-size: 0.9em;
}

.repostajes-gasolinera-nombre {
  display: block;
}

.repostajes-gasolinera-direccion {
  color: #a098ae;
  display: block;
  font-weight: 400 !important;
}

.repostajes-download-title {
  color: #db0b27;
  text-align: right !important;
  cursor: pointer;
  display: flex !important;
}

.repostajes-download {
  text-align: center !important;
}

.repostajes-table-select {
  display: inline;
  vertical-align: super;
}

.repostajes-table-select > input[type="checkbox"] {
  padding: 0.6em;
  margin: 0.6em 1.1em;
  cursor: pointer;
}

.filters-mobile-nav {
  max-height: 70vh;
  overflow-y: scroll;
}

.repostaje-download-ticket-span-cursor {
  cursor: pointer;
}

.repostaje-download-ticket-btn {
  width: 31px;
  height: 24px;
}

.repostaje-download-ticket-btn.disabled {
  opacity: 0.5;
}

.repostajes-solicitud-x-btn {
  cursor: pointer;
  width: 22px;
  height: 22px;
}

#buscadorRepostajes {
  padding: 0 1em;
}

#dropdown-basic-button-meses {
  width: 9em;
  max-width: 9em;
}

.export-btn-color {
  color: #db0b27;
} /* color por defecto (gris) */
.export-btn-color:hover {
  color: #fff;
} /* color al hacer hover (rojo - bootstrap danger) */

.filter-select-filters.repostajes {
  padding-left: 0;
  padding-right: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  justify-content: space-evenly;
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  table.repostajes th,
  table.repostajes td {
    display: table-cell !important;
  }

  table.repostajes tr,
  table.repostajes td {
    border-bottom: none;
  }

  table.repostajes thead {
    border-bottom: 1px solid #dbdbdb;
  }

  table.repostajes th,
  table.repostajes th:last-child,
  table.repostajes td {
    text-align: left;
  }

  .filter-select-filters.repostajes {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/repostajes/repostajes.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB,EAAE,6BAA6B;AAC/B;EACE,WAAW;AACb,EAAE,mDAAmD;;AAErD;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["table.repostajes > :not(:first-child) {\n  border-top: none;\n}\n\ntable.repostajes tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\ntable.repostajes > thead > tr > th:last-child,\ntable.repostajes > tbody > tr > td:last-child {\n  text-align: left;\n}\n\ntable.repostajes td {\n  font-weight: 600;\n  padding-bottom: 1.75em;\n  padding-top: 1.75;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.repostajes-fecha {\n  color: #a098ae;\n  font-weight: 600 !important;\n}\n\n.repostajes-matricula {\n  text-transform: uppercase;\n}\n\nspan.repostajes-fecha-hora {\n  display: block;\n  font-weight: 400;\n  font-size: 0.9em;\n}\n\n.repostajes-gasolinera-nombre {\n  display: block;\n}\n\n.repostajes-gasolinera-direccion {\n  color: #a098ae;\n  display: block;\n  font-weight: 400 !important;\n}\n\n.repostajes-download-title {\n  color: #db0b27;\n  text-align: right !important;\n  cursor: pointer;\n  display: flex !important;\n}\n\n.repostajes-download {\n  text-align: center !important;\n}\n\n.repostajes-table-select {\n  display: inline;\n  vertical-align: super;\n}\n\n.repostajes-table-select > input[type=\"checkbox\"] {\n  padding: 0.6em;\n  margin: 0.6em 1.1em;\n  cursor: pointer;\n}\n\n.filters-mobile-nav {\n  max-height: 70vh;\n  overflow-y: scroll;\n}\n\n.repostaje-download-ticket-span-cursor {\n  cursor: pointer;\n}\n\n.repostaje-download-ticket-btn {\n  width: 31px;\n  height: 24px;\n}\n\n.repostaje-download-ticket-btn.disabled {\n  opacity: 0.5;\n}\n\n.repostajes-solicitud-x-btn {\n  cursor: pointer;\n  width: 22px;\n  height: 22px;\n}\n\n#buscadorRepostajes {\n  padding: 0 1em;\n}\n\n#dropdown-basic-button-meses {\n  width: 9em;\n  max-width: 9em;\n}\n\n.export-btn-color {\n  color: #db0b27;\n} /* color por defecto (gris) */\n.export-btn-color:hover {\n  color: #fff;\n} /* color al hacer hover (rojo - bootstrap danger) */\n\n.filter-select-filters.repostajes {\n  padding-left: 0;\n  padding-right: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5em;\n  justify-content: space-evenly;\n}\n\n/* BREAKPOINT ESCRITORIO */\n@media (min-width: 992px) {\n  table.repostajes th,\n  table.repostajes td {\n    display: table-cell !important;\n  }\n\n  table.repostajes tr,\n  table.repostajes td {\n    border-bottom: none;\n  }\n\n  table.repostajes thead {\n    border-bottom: 1px solid #dbdbdb;\n  }\n\n  table.repostajes th,\n  table.repostajes th:last-child,\n  table.repostajes td {\n    text-align: left;\n  }\n\n  .filter-select-filters.repostajes {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
